import styled from 'styled-components'
import { buttonPrimary } from 'app/sofia/resources/theme/css'

export const CheckoutButton = styled.div`
  padding: 15px 0 0;
  margin: 0;

  button {
    display: block;
    width: 100%;
    ${buttonPrimary}
    height: ${props => props.theme.palette.general.buttonSizeLg};
    font-weight: 600;
    font-size: 18px;
  }
`

export const LivbriteButton = styled.div`
  padding: 25px 0 0;
  margin: 0 0 20px;

  button {
    background: ${props => props.theme.palette.primary.alpha};
    display: block;
    width: 100%;
    font-weight: bold;
    font-size: 18px;

    :hover {
      background: ${props => props.theme.palette.primary.alphaDark};
    }
  }
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 10px;
`

export const ModalContent = styled.div`
  text-align: center;

  h1 {
    line-height: 1.2;
  }
`
